export const normalizeLength = (length: number) => (value: string) => value?.substring(0, length);
export const normalizeCharacters = (length: number) => (value: string) =>
  value && normalizeLength(length)(value.replace(/[^A-Za-z0-9]/g, ''));
export const normalizeUsername = (value: string) =>
  value && normalizeCharacters(50)(value.toLowerCase());
